// Sprint LOOP action names (W1). The server lists, per resource, the actions
// the caller may take (`allowedActions`); the web renders exactly that list
// and never re-derives roles (AVR, #2950 6226605342).
//
// The names come from SL.C1's one shared constant (packages/shared
// sprintActions.ts, #3553), never retyped here (rulings 6223680139 item 3,
// 6229870839). Reserved names are included in the type so a story can name
// one before its check exists; the server never lists a reserved name.
// sprintLoopActions.test.ts pins this module to the shared constant.
export {
  SPRINT_ACTIONS,
  SPRINT_CONFIG_ACTIONS, // SL.L3a (#2959, ruling D3): the sprint settings card
  BACKLOG_ACTIONS,
  RESERVED_SPRINT_ACTIONS,
  SPRINT_ITEM_DISPOSITIONS, // L1's close dialog (G1)
} from '@blueprint/shared';
export type { SprintAction, SprintConfigAction, BacklogActionName, ReservedSprintAction } from '@blueprint/shared';

import type { SprintAction, SprintConfigAction, BacklogActionName, ReservedSprintAction } from '@blueprint/shared';

/** Every action name the web may ask about. */
export type SprintLoopActionName = SprintAction | SprintConfigAction | BacklogActionName | ReservedSprintAction;

/** Whether the server listed `action`. Typed, so a misspelt name fails to compile. */
export function hasAction(
  allowedActions: readonly string[] | undefined,
  action: SprintLoopActionName,
): boolean {
  return !!allowedActions?.includes(action);
}
